module.exports = __webpack_public_path__ + "img/desktop-background.9e4ee766.png";